<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex order-xs2 order-md2 xs12 md6>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="nameErrors"
                      v-model="$v.userForm.firstName.$model"
                      label="Nombre(s)"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="lastNameErrors"
                      v-model="$v.userForm.lastName.$model"
                      label="Apellidos"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :error-messages="levelErrors"
                      label="Nivel"
                      :items="levels"
                      outline
                      height="50"
                      return-object
                      item-text="typeLevel"
                      @change="filterGGsByLevel"
                      :dense="$vuetify.breakpoint.xsOnly"
                      v-model="$v.userForm.level.$model"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :error-messages="ggErrors"
                      label="Grado y grupo"
                      :items="ggs"
                      outline
                      height="50"
                      return-object
                      :item-text="text"
                      v-model="$v.userForm.gg.$model"
                      :dense="$vuetify.breakpoint.xsOnly"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      :error-messages="personIdErrors"
                      v-model="$v.userForm.personId.$model"
                      label="Matrícula"
                    ></v-text-field>
                  </v-flex>
                  <v-flex>
                    <v-radio-group
                      v-model="$v.userForm.gender.$model"
                      color="primary"
                      :error-messages="genderErrors"
                    >
                      <v-radio color="primary" label="Masculino" value="MALE"></v-radio>
                      <v-radio color="primary" label="Femenino" value="FEMALE"></v-radio>
                    </v-radio-group>
                  </v-flex>

                   <v-flex xs12>
                      <v-text-field
                          v-model="$v.userForm.email.$model"
                          label="Correo electrónico"
                          outline
                         :error-messages="processErrorEmail"
                        ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                     <v-text-field
                      v-model="$v.userForm.place.$model"
                      label="Dirección"
                      :error-messages="processErrorPlace"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                        :prefix="flagSelection"
                        v-model="$v.userForm.phone.$model"
                        label="Teléfono"
                        outline
                        mask="(###) ### - ####"
                        :error-messages="processErrorPhone"
                    >
                    </v-text-field>
                  </v-flex>

                   <v-flex xs12>
            <v-menu
              v-model="modalL"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="momentFormatFirst"
                  id="last"
                  label="Fecha de nacimiento"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                header-color="primary"
                color="secondary"
                locale="es-419"
                v-model="userForm.birthDate"
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-flex>
                <!-- <v-layout row wrap>
                    <v-flex xs12>
                    <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date"
                        label="Fecha de nacimiento"
                        prepend-icon="event"
                        locale="es-419"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                    </v-flex>
                    <v-spacer></v-spacer>
                </v-layout> -->

                



                </v-layout>
              </v-flex>
              <v-flex order-xs1 order-md2 xs8 offset-xs2 md6 offset-md0>
                <v-layout
                  align-center
                  justify-center
                  row
                  fill-height
                  wrap
                  v-on:mouseover="flags.updateImage = true"
                  v-on:mouseleave="flags.updateImage = false"
                >
                  <v-flex style="text-align: center;" sm7 v-show="working.wImage">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-flex>
                  <v-flex
                    v-show="!working.wImage"
                    xs7
                    style="border-radius: 50%;"
                    id="parentContainerEmployeeImage"
                    :class="!flags.changed && (!student || !student.imageStorage || !student.imageStorage.miniObjUrl ? 'gradiente' : '')"
                  >
                    <label id="img_edit_employee_default">
                      <v-img
                        v-if="!student || !student.imageStorage || !student.imageStorage.miniObjUrl"
                        :src="require('@/assets/panel/modals/AddPhotoIcon@3x.png')"
                      ></v-img>
                      <v-img
                        style="border-radius: 50%; text-align:center;"
                        v-else
                        :src="student.imageStorage.miniObjUrl"
                      ></v-img>
                    </label>
                    <label style="display: none; text-align: center;" id="img_edit_employee"></label>

                    <!-- <input
											type="file"
											id="edit_logo"
											name="edit_logo"
											accept="image/*"
											style="display: none;"
											@change="processImage($event)"
                    >-->
                  </v-flex>
                  <br />
                  <v-flex xs7>
                    <v-expand-transition>
                      <v-btn
                        block
                        class="gradiente"
                        style="border-radius: 33px;"
                        v-show="flags.updateImage"
                        dark
                        @click="modals.image = true"
                      >Actualizar</v-btn>
                    </v-expand-transition>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.wUpdate" flat @click="close">Cancelar</v-btn>
          <v-btn :disabled="working.wUpdate" color="primary darken-1" flat @click="submit">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading v-model="working.wUpdate" text="Trabajando..."></loading>
    <success v-if="student != null" v-model="toast.success" text="Creación Exitosa"></success>
    <success v-else v-model="toast.success" text="Actualización Exitosa"></success>
    <error v-model="toast.failed" :text="toast.fmessage"></error>
    <editImage
      :title="(userForm.image != null) ? 'Editar imagen' : 'Añadir imagen'"
      v-on:loaded="processImage($event)"
      v-model="modals.image"
    ></editImage>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import { funciones } from "../../Mixins/Funciones.js";
import loading from "../Dialogs/Loading.vue";
import success from "../Dialogs/Success.vue";
import error from "../Dialogs/Error.vue";
import editImage from "../Modals/EditImage";
import { setTimeout } from "timers";
export default {
  props: ["title", "parent", "value", "student"],
  components: {
    loading,
    success,
    error,
    editImage
  },
  validations: {
    userForm: {
      firstName: { required },
      lastName: { required },
      gender: { required },
      personId: { required },
      level: { required },
      gg: { required },
      email: { required, email },
      place: { required },
      phone: { required },


       
    }
  },
  watch: {
    value() {
      this.getLevels();
    }
  },

  mounted() {},
  data: () => ({
    modals: {
      image: false
    },
    userForm: {
      firstName: "",
      lastName: "",
      gender: "",
      personId: "",
      level: {},
      gg: {},
      //v2
      email: "",
      place: "",
      phone: "",
      birthDate: new Date().toISOString().substr(0, 10),
    },  
    userImg: null,
    working: {
      wUpdate: false,
      wImage: false
    },
    toast: {
      success: false,
      failed: false,
      fmessage: "Ups ocurrió un error"
    },
    flags: {
      updateImage: false,
      changed: false
    },
    flagSelection: "+52",
    levels: [],
    ggs: [],
    selectedLevel: {},
    stdIdToAdd: {},
    timeLast: new Date().toISOString().substr(0, 10),
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    modalL: false,
  }),
  methods: {
    text: item => item.grade + "" + item.group,
    setInfoToShowOnUpdate() {
      if (this.value) {
        if (this.student != null) {
          this.userForm.id = this.student.id;
          this.userForm.firstName = this.student.firstName;
          this.userForm.lastName = this.student.lastName;
          this.userForm.personId = this.student.personId;
          this.userForm.gender = this.student.gender;
          this.userForm.personId = this.student.personId;
          this.userForm.level = this.student.level;
          this.userForm.email = this.student.email;
          for (var lvl in this.levels) {
            if (this.student.level.id == this.levels[lvl].id) {
              this.ggs = this.levels[lvl].ggs;
              this.$forceUpdate();
              break;
            }
          }
          this.userForm.gg = this.student.gg;
          if (
            this.student.image != null &&
            this.student.image != "" &&
            this.student.image != "data:image/jpeg;base64,undefined" &&
            this.student.image != "data:image/jpeg;base64," &&
            this.student.image != "data:image/jpeg;base64, "
          ) {
            this.processImage(this.student.image);
          }
        }
      }
    },
    getLevels() {
      this.working.wUpdate = true;
      this.$store
        .dispatch("tutor/getLevelsParentTool")
        .then(response => {
          this.levels = response.data.entity.levels;
          this.working.wUpdate = false;
          this.setInfoToShowOnUpdate();
        })
        .catch(error => {
          console.log(error);
          this.working.wUpdate = false;
          this.toast.failed = true;
        });
    },

    processImage(event) {
      this.working.wImage = true;
      this.userForm.image = event.split(",")[1];
      document.getElementById(
        "img_edit_employee"
      ).innerHTML = `<img class="elevation-4" src="${event}" style='width: 120px; height: 120px; object-fit: cover; border-radius: 50%;'>`;
      document.getElementById("img_edit_employee").style.display = "block";
      document.getElementById("img_edit_employee_default").style.display =
        "none";
      this.working.wImage = false;
      this.flags.changed = true;
    },
    submit() {
      this.$v.userForm.$touch();
      if (!this.$v.userForm.$invalid) {
        this.working.wUpdate = true;
        if (this.student == null) {
          var obj = this.userForm;
          this.$store
            .dispatch("student/createStudent", obj)
            .then(response => {
              this.stdIdToAdd = response.data.entity;

              if (this.parent != null) {
                this.$store
                  .dispatch("tutor/addChildToParent", {
                    pid: this.parent,
                    sid: this.stdIdToAdd.id
                  })
                  .then(res => {
                    this.working.wUpdate = false;
                    this.$v.$reset();
                    this.$emit("created", response.data.entity);
                    this.close();
                  })
                  .catch(error => {
                    this.working.wUpdate = false;
                    this.toast.failed = true;
                    if (error.status == 200) {
                      this.toast.fmessage = error.data.message;
                    }
                    console.log(error);
                  });
              } else {
                this.working.wUpdate = false;
                this.$emit("created", response.data.entity);
                this.close();
              }
            })
            .catch(error => {
              this.working.wUpdate = false;
              this.toast.failed = true;
              if (error.status == 200) {
                this.toast.fmessage = error.data.message;
              }
              console.log(error);
            });
        } else {
          var obj = this.userForm;

          this.$store
            .dispatch("student/updateStudent", obj)
            .then(response => {
              this.working.wUpdate = false;
              this.$v.$reset();
              this.toast.success = true;
              response.data.entity.image =
                "data:image/jpeg;base64," + response.data.entity.image;

              this.$emit("updated", response.data.entity);
              this.close();
            })
            .catch(error => {
              this.working.wUpdate = false;
              this.toast.failed = true;
              if (error.status == 200) {
                this.toast.fmessage = error.data.message;
              }
              console.log(error);
            });
        }
      }
    },
    close() {
      this.$v.$reset();
      document.getElementById("img_edit_employee").innerHTML = ``;
      document.getElementById("img_edit_employee").style.display = "none";
      document.getElementById("img_edit_employee_default").style.display =
        "block";
      this.flags.changed = false;

      this.userForm = {
        firstName: "",
        lastName: "",
        gender: "",
        personId: "",
        level: {},
        gg: {},
        //v2
        email: "",
        place: "",
        phone: "",
        birthDate:"",
      };
      this.$emit("input", !this.value);
      this.$emit("onClosed", false);
    },
    filterGGsByLevel(val) {
      this.levels.filter(item => {
        if (item.id == val.id) {
          this.ggs = item.ggs;
          this.$forceUpdate();
        }
      });
    },
    handleKeyDown(e) { //method to handle the keypress
      if (e.code === "Escape") {
        this.close();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown); //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown); //will detach the event listener once the component is destroyed
  },

  computed: {
    levelErrors() {
      const errors = [];
      if (!this.$v.userForm.level.$dirty) return errors;
      !this.$v.userForm.level.required && errors.push("Nivel obligatorio");

      return errors;
    },
    ggErrors() {
      const errors = [];
      if (!this.$v.userForm.gg.$dirty) return errors;
      !this.$v.userForm.gg.required &&
        errors.push("Grado y grupo obligatorios");

      return errors;
    },

    personIdErrors() {
      const errors = [];
      if (!this.$v.userForm.personId.$dirty) return errors;
      !this.$v.userForm.personId.required &&
        errors.push("Matrícula obligatoria");

      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.userForm.lastName.$dirty) return errors;
      !this.$v.userForm.lastName.required &&
        errors.push("Apellidos obligatorios");

      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.userForm.firstName.$dirty) return errors;
      !this.$v.userForm.firstName.required && errors.push("Nombre obligatorio");
      return errors;
    },
    genderErrors() {
      const errors = [];
      if (!this.$v.userForm.gender.$dirty) return errors;
      !this.$v.userForm.gender.required && errors.push("Genero obligatorio");
      return errors;
    },
    //errores V2 
    processErrorPhone() {
      const errors = [];
      if (!this.$v.userForm.phone.$dirty) return errors;
      !this.$v.userForm.phone.required &&
        errors.push("El teléfono es requerido");
      return errors;
    },
    processErrorEmail() {
      const errors = [];
      if (!this.$v.userForm.email.$dirty) return errors;
      !this.$v.userForm.email.required && errors.push("El correo es requerido");
      !this.$v.userForm.email.email && errors.push("El correo no es valido");
      return errors;
    },
    processErrorPlace() {
      const errors = [];
      if (!this.$v.userForm.place.$dirty) return errors;
      !this.$v.userForm.place.required &&
        errors.push("Dirección requerida ");
      return errors;
    },
    momentFormatFirst() {
      if (this.userForm.birthDate != null) {
        return moment(this.userForm.birthDate).format("DD/MM/YYYY");
      }
      return "";
    }
  }
};
</script>

<style>
.no-properties {
  width: 0% !important;
  height: 0% !important;
}
</style>
